// import Swiper JS
import Swiper, { Navigation, Pagination, Autoplay,EffectFade } from 'swiper';
//import SwiperAnimation from '@cycjimmy/swiper-animation';
//import "animate.css"

// import Swiper styles
import 'swiper/swiper-bundle.css';

const $ = window.jQuery;


const heroSwiper = {

    init() {
    var $heroSwiper = $(document).find('#heroSwiper');

        if (!$heroSwiper.length)
            return;


            var speed = $heroSwiper.attr('data-speed');
               console.log(speed);
            // configure Swiper to use modules
          Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);
       //   const swiperAnimation = new SwiperAnimation();
            const swiper = new Swiper("#heroSwiper", {
              effect: "fade",
              fadeEffect: { // Add this
                crossFade: true,
              },
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                infinit: false,
                cache:false,
                autoplay: {
                  delay: speed,
                  disableOnInteraction: false,
                },

              pagination: {
                el: ".swiper-pagination",
                clickable: true,
              },
            
              });

         

              
       
    },

};

export default heroSwiper;
